module.exports = __webpack_public_path__ + "img/15.b7c3440e.png";